import { FrameEditOrder } from '@Modules/Orders';
import { useLinkedObjectOverlay } from '@synqo/frontend-component-library';

/** Opens an order by id in an overlay. */
// @ai-generated 2026-10-29T14:00:00+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
export function useOpenOrder() {
    const { onClick } = useLinkedObjectOverlay({ Renderer: FrameEditOrder, canAdd: false });
    return onClick;
}
